var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPracticeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.667.667c1.104 0 2 .895 2 2v10.666c0 1.105-.896 2-2 2H3.333c-1.104 0-2-.895-2-2V2.667c0-1.105.896-2 2-2h9.334zm0 1.333H3.333c-.368 0-.666.298-.666.667v10.666c0 .369.298.667.666.667h9.334c.368 0 .666-.298.666-.667V2.667c0-.369-.298-.667-.666-.667zm-2.27 1.66l.943.943c.521.52.521 1.364 0 1.885l-4.484 4.484c-.198.199-.454.33-.732.374-1.408.225-1.931.251-2.283-.1-.337-.338-.334-.87-.182-2.314.032-.303.167-.587.383-.803l4.47-4.47c.52-.52 1.365-.52 1.885 0zM12 10c.368 0 .667.298.667.667 0 .368-.299.666-.667.666h-2c-.368 0-.667-.298-.667-.666 0-.369.299-.667.667-.667h2zM9.455 4.603l-4.47 4.47c-.048.458-.076.822-.082 1.086.25-.019.588-.062 1.01-.13l4.484-4.484-.942-.942z",
    transform: "translate(-1072 -309) translate(1040 64) translate(0 197) translate(32 48)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPracticeIcon);
export default __webpack_public_path__ + "static/media/practice-icon.594c1469.svg";
export { ForwardRef as ReactComponent };